import React, { useState } from "react";
import { postDashboardLogin, formatApiError } from "./api";

export default function DashboardLogin({ onSuccess, hint }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(null);
    setBusy(true);
    try {
      await postDashboardLogin({ username, password });
      onSuccess();
    } catch (ex) {
      setErr(ex?.raw ? formatApiError(ex.raw) : ex?.message || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#04080f",
        padding: 24,
      }}
    >
      <form
        onSubmit={submit}
        style={{
          width: "100%",
          maxWidth: 380,
          background: "#060d1a",
          border: "1px solid #1e293b",
          borderRadius: 12,
          padding: 28,
          boxShadow: "0 24px 48px #0006",
        }}
      >
        <div style={{ fontFamily: "'Syne',sans-serif", fontSize: 18, fontWeight: 800, color: "#f1f5f9", marginBottom: 6 }}>
          Dashboard sign-in
        </div>
        <div style={{ fontSize: 11, color: "#64748b", marginBottom: 22, lineHeight: 1.5 }}>
          {hint ? (
            <span style={{ color: "#94a3b8" }}>{hint}</span>
          ) : (
            <>
              Set <code style={{ color: "#f59e0b" }}>DASHBOARD_USERNAME</code> and{" "}
              <code style={{ color: "#f59e0b" }}>DASHBOARD_PASSWORD</code> in the{" "}
              <strong style={{ color: "#cbd5e1" }}>backend</strong> <code style={{ color: "#f59e0b" }}>.env</code> (same folder
              as <code style={{ color: "#f59e0b" }}>server.js</code>), then restart Node. This gate is not read from the React app
              env file.
            </>
          )}
        </div>
        <label style={{ display: "block", fontSize: 10, color: "#475569", marginBottom: 6, letterSpacing: "0.06em" }}>
          USERNAME
        </label>
        <input
          autoComplete="username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          style={{
            width: "100%",
            boxSizing: "border-box",
            marginBottom: 14,
            padding: "10px 12px",
            borderRadius: 8,
            border: "1px solid #334155",
            background: "#0a1628",
            color: "#e2e8f0",
            fontFamily: "'DM Mono',monospace",
            fontSize: 13,
          }}
        />
        <label style={{ display: "block", fontSize: 10, color: "#475569", marginBottom: 6, letterSpacing: "0.06em" }}>
          PASSWORD
        </label>
        <input
          type="password"
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={{
            width: "100%",
            boxSizing: "border-box",
            marginBottom: 18,
            padding: "10px 12px",
            borderRadius: 8,
            border: "1px solid #334155",
            background: "#0a1628",
            color: "#e2e8f0",
            fontFamily: "'DM Mono',monospace",
            fontSize: 13,
          }}
        />
        {err && (
          <div style={{ fontSize: 11, color: "#f87171", marginBottom: 14, lineHeight: 1.4 }}>
            {err}
          </div>
        )}
        <button
          type="submit"
          disabled={busy}
          style={{
            width: "100%",
            padding: "12px",
            borderRadius: 8,
            border: "none",
            cursor: busy ? "wait" : "pointer",
            background: "linear-gradient(135deg,#22c55e,#0ea5e9)",
            color: "#020617",
            fontWeight: 700,
            fontFamily: "'DM Mono',monospace",
            fontSize: 12,
            letterSpacing: "0.05em",
          }}
        >
          {busy ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </div>
  );
}
